<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="fullPage">
            </loading>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0" v-if="0">
                  <b-row>
                    <b-col cols="12">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="3" >
                    <base-input :label="language_terms['AS_OF_DATE']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="date_to">
                      </flat-picker>
                    </base-input>
                  </b-col>                    
 
                    <b-col md="4">
                        <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                        <productLookup v-bind:url="apiProductLookup" v-on:selected="product_code_from = $event.code" :lookupId="item.product_code"/>
                    </b-col>
                    <b-col md="4">
                        <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                        <productLookup v-bind:url="apiProductLookup" v-on:selected="product_code_to = $event.code" :lookupId="item.product_code"/>
                    </b-col>

                  <b-col cols="1" class="mt-4">
                    <base-button type="primary"  @click="clickOnGenerate" class="mt-2 mr-4">{{language_terms['RUN']}}</base-button>
                  </b-col>
                </b-row>
              </card>
              <!-- Search Results -->
                <v-client-table v-if="items.length > 0" v-model="items" :columns="reportColumns" :options="reportOptions" >
                </v-client-table>
              <!-- <PaginatedTables :myColumns="tableColumns" :tableData="items"  v-if="items.length > 0 && type !='DO'"/>
              <PaginatedTables :myColumns="do_tableColumns" :tableData="items"  v-if="items.length > 0 && type =='DO'"/> -->

            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
th.VueTables__sortable {
    color:rgb(255,255,255);
}
td.VueTables__row  {
    color:black
}
</style>
<script>
import productLookup from "@/components/Autocomplete.vue";
import moment from 'moment'
import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

export default {
  components:{
    productLookup,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed: {
    ...mapState({
        language_terms: (state) => state.languages.language_terms,
        selected_lang: (state) => state.languages.selected_langauge,
    })
  },  
  async mounted()
  {
    this.date_to = moment().format("YYYY-MM-DD")
  },
  data(){
    return{
        product_code_from:null,
        product_code_to:null,
        item:[],
        apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
        product_id:null,
        customers:[],
        customer:null,
        contact_name:null,
        date_from:null,
        date_to:null,
        fullPage:true,
        loading:false,
        items:[],
        reportOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false},
        reportColumns:['Customer','Item Code','Item Description','Date', 'Invoice', 'Quantity','Unit Price', 'Exch Rate'],
        

    }
  },

  methods:{
    async selectProduct(product)
    {
        this.product_id = product.id
    },    
    async onSelectCustomer(selectedOption) {
        this.customer = selectedOption
    },    
    async asyncFindCustomer(query) 
    {
      let pv = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          } else {
            this.customers = [];
          }

          this.loadingCounter--;
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            Vue.notify({
              group: "notify",
              type: "error",
              text: error.response.data.msg,
              max: 5,
              duration: 5000,
              speed: 300,
            });
          } else {
            console.log("Problem submitting New Post", error);
          }
        });
    },
    updateTableLang(){
      if(this.type != 'DO')
      {
        for(let i=0; i < this.tableColumns.length;i++)
        {
          let key = this.tableColumns[i].key
          this.tableColumns[i].label = this.language_terms[key]
        }
      }
      else
      {
        for(let i=0; i < this.do_tableColumns.length;i++)
        {
          let key = this.do_tableColumns[i].key
          this.do_tableColumns[i].label = this.language_terms[key]
        }
      }

    },
    async clickOnGenerate(){
        this.loading = true

        let payload = { date:this.date_to, product_from: this.product_code_from, product_to: this.product_code_to};
        await axios.post(apiRoutes["REPORTS_INVENTORY_STOCK_BALANCE"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) {
                console.log(response.data.data)
                console.log(response.data.data.headers)
                this.reportColumns = response.data.data.headers
                this.items = response.data.data.rows
            } else {

            }

            this.loadingCounter--;
        })
        .catch((error) => {
            if (error.response) {
            console.log(error.response);
            Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
            });
            } else {
            console.log("Problem submitting New Post", error);
            }
        });

this.loading = false
    },

  }
}
</script>
